/**
 * 部材フィルター：? アイコンクリックで説明文ツールチップを表示
 * 説明文はメタオブジェクト「部材フィルター説明」の JSON から取得
 */
(function () {
  function getDescriptions() {
    var el = document.getElementById('buzai-filter-descriptions');
    if (!el || !el.textContent || !el.textContent.trim()) return {};
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return {};
    }
  }

  function init() {
    var descriptions = getDescriptions();
    var container = document.querySelector('.densaku-buzai-search');
    if (!container) return;

    var tooltipEl = null;

    function createTooltip() {
      if (tooltipEl) return tooltipEl;
      tooltipEl = document.createElement('div');
      tooltipEl.className = 'densaku-buzai-tooltip';
      tooltipEl.setAttribute('role', 'tooltip');
      tooltipEl.setAttribute('hidden', '');
      container.appendChild(tooltipEl);
      return tooltipEl;
    }

    function hideTooltip() {
      if (tooltipEl) {
        tooltipEl.setAttribute('hidden', '');
        tooltipEl.textContent = '';
      }
    }

    function showTooltip(trigger, text) {
      if (!text || !text.trim()) return;
      var tip = createTooltip();
      tip.textContent = text.trim();
      tip.removeAttribute('hidden');

      var rect = trigger.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      var padding = 8;
      var subgroup = trigger.closest('.densaku-buzai-subgroup');

      if (subgroup) {
        var subgroupRect = subgroup.getBoundingClientRect();
        tip.style.left = (subgroupRect.left - containerRect.left) + 'px';
        tip.style.width = subgroupRect.width + 'px';
        tip.style.minWidth = 'auto';
        tip.style.maxWidth = Math.min(subgroupRect.width, window.innerWidth - padding * 2) + 'px';
      } else {
        tip.style.minWidth = Math.max(rect.width, 200) + 'px';
        tip.style.width = '';
        tip.style.maxWidth = '';
        tip.style.left = (rect.left - containerRect.left) + 'px';
      }

      tip.style.top = (rect.bottom - containerRect.top + container.scrollTop + 6) + 'px';
      tip.classList.remove('is-above');

      var tipRect = tip.getBoundingClientRect();

      if (tipRect.right > window.innerWidth - padding) {
        var leftAdjusted = (window.innerWidth - padding - tipRect.width) - containerRect.left;
        tip.style.left = Math.max(0, leftAdjusted) + 'px';
      }
      tipRect = tip.getBoundingClientRect();
      if (tipRect.left < padding) {
        tip.style.left = Math.max(0, padding - containerRect.left) + 'px';
      }

      tipRect = tip.getBoundingClientRect();
      if (tipRect.bottom > window.innerHeight - padding) {
        var topAbove = rect.top - containerRect.top - tip.offsetHeight - 6;
        tip.style.top = Math.max(0, topAbove) + 'px';
        tip.classList.add('is-above');
      }
      tipRect = tip.getBoundingClientRect();
      if (tipRect.top < padding) {
        tip.style.top = Math.max(0, padding - containerRect.top) + 'px';
      }

      tipRect = tip.getBoundingClientRect();
      var triggerCenterX = (rect.left + rect.width / 2) - tipRect.left;
      tip.style.setProperty('--tooltip-tail-left', triggerCenterX + 'px');
    }

    container.addEventListener('click', function (e) {
      var trigger = e.target.closest('.js-buzai-tooltip-trigger');
      if (!trigger) {
        hideTooltip();
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      var key = trigger.getAttribute('data-description-key');
      var text = key ? descriptions[key] : '';
      if (text) {
        showTooltip(trigger, text);
      } else {
        hideTooltip();
      }
    });

    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      hideTooltip();
    });

    document.addEventListener('click', function (e) {
      if (!container.contains(e.target)) hideTooltip();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
